import { PATH_RELEASE_CREATE, PATH_RELEASE_EDIT, PATH_RELEASE_LIST } from 'app/constants/routes';
import React from 'react';

const ReleasePagesConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: PATH_RELEASE_CREATE,
            exact: true,
            component: React.lazy(() => import('./ReleaseForm'))
        },
        {
            path: PATH_RELEASE_LIST,
            exact: true,
            component: React.lazy(() => import('./ReleasePage'))
        },
        {
            path: `${PATH_RELEASE_EDIT}/:id`,
            exact: true,
            component: React.lazy(() => import('./ReleaseForm'))
        },
    ]
};

export default ReleasePagesConfig;
